import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const webPractik = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img1.png',
            crewItemTitle: 'Мария Муштатова',
            crewItemSubtitle: 'старший менеджер проектов',
        },
        {
            crewItemImg: '/images/svg/skolkovo/ace-ventura.jpg',
            crewItemTitle: 'Евгения Шестакова',
            crewItemSubtitle: 'руководитель отдела контекстной рекламы',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Эрик Сон',
            crewItemSubtitle: 'специалист по контекстной рекламе',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="mid-team">
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={webPractik} />
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Team;
